import React, { useEffect, useState, useRef } from "react";
import {
    Row,
    Col,
    Form,
    Input,
    Select,
    Button,
} from '../../ui/ot'
import dayjs from 'dayjs'
import { useTranslation } from "react-i18next";
import { useCRUDController } from "../../ui/classify_structure/CRUDController";
const MARC008GeneratorForm = ({
    keyPrefix = 'cataloging.AddMARC',
    propsForm,
    field,
    leader = '',
    tag008 = "",
    onFormFinish = () => { },
}) => {
    const [form_] = Form.useForm();
    const form = propsForm ? propsForm : form_
    const [count, setCount] = useState(0);
    const [show, setShow] = useState(true)
    const [materialType, setMaterialType] = useState("BKS")
    const { t } = useTranslation('translation', { keyPrefix })
    const changeMode = useRef("select")
    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊

    };
    const onFinish = (values) => {
        onFormFinish({
            ...values,
        });
    };
    const onValuesChange = (value, { name, type }) => {
        console.log({
            value,
            name
        })

    };
    const setDifferent008DefaultValuesByDifferentMaterialTypes = (materialType) => {
       
        let f0_f5 = dayjs().format("YYYYMMDD")
        f0_f5 = f0_f5.slice(2, 8)
        if (materialType === "BKS") {
            form.resetFields()
            form.setFieldsValue({
                "f0_f5": f0_f5,
                "f6": "b",
                "f7_f10": "    ",
                "f11_f14": "    ",
                "f15_f17": "|||",
                "f18": "|",
                "f19": "|",
                "f20": "|",
                "f21": "|",
                "f22": "|",
                "f23": " ",
                "f24": "|",
                "f25": "|",
                "f26": "|",
                "f27": "|",
                "f28": " ",
                "f29": "0",
                "f30": "0",
                "f31": "|",
                "f32": " ",
                "f33": "0",
                "f34": " ",
                "f35_f37": "eng",
                "f38": " ",
                "f39": "d"
            })

        }
        else if (materialType === "CF") {
            form.resetFields()
            form.setFieldsValue({
                "f0_f5": f0_f5,
                "f6": "b",
                "f7_f10": "    ",
                "f11_f14": "    ",
                "f15_f17": "|||",
                "f18_f21": "||||",
                "f22": "|",
                "f23": " ",
                "f24_f25": "||",
                "f26": "|",
                "f27": "|",
                "f28": " ",
                "f29_f34": "00| 0 ",
                "f35_f37": "eng",
                "f38": " ",
                "f39": "d"
            })
        }
        else if (materialType === "CR") {
            form.resetFields()
            form.setFieldsValue({
                "f0_f5": f0_f5,
                "f6": "b",
                "f7_f10": "    ",
                "f11_f14": "    ",
                "f15_f17": "|||",
                "f21": "|",
                "f22": "|",
                "f23": "|",
                "f24": "|",
                "f25_f27": "|||",
                "f30_f32": "0|#",
                "f33": " ",
                "f34": "0",
                "f35_f37": "eng",
                "f38": " ",
                "f39": "d",
                "f18": "|",
                "f19": "|",
                "f20": "|",
                "f28": " ",
                "f29": "0"
            })

        }
        else if (materialType === "MP") {
            form.resetFields()
            form.setFieldsValue({
                "f0_f5": f0_f5,
                "f6": "b",
                "f7_f10": "    ",
                "f11_f14": "    ",
                "f15_f17": "|||",
                "f18_f21": "||||",
                "f22_f23": "| ",
                "f24": "|",
                "f25": "|",
                "f26_f27": "||",
                "f28": " ",
                "f29": " ",
                "f30": " ",
                "f31": "|",
                "f32": " ",
                "f33_f34": "  ",
                "f35_f37": "eng",
                "f38": " ",
                "f39": "d"
            })
        }
        else if (materialType === "MU") {
            form.resetFields()
            form.setFieldsValue({
                "f0_f5": f0_f5,
                "f6": "b",
                "f7_f10": "    ",
                "f11_f14": "    ",
                "f15_f17": "|||",
                "f18_f19": "||",
                "f20": "|",
                "f21": "|",
                "f22": "|",
                "f23": " ",
                "f24_f29": "|||| 0",
                "f30_f31": "0|",
                "f32": " ",
                "f33": " ",
                "f34": " ",
                "f35_f37": "eng",
                "f38": " ",
                "f39": "d"
            })

        }
        else if (materialType === "MX") {
            form.resetFields()
            form.setFieldsValue({
                "f0_f5": f0_f5,
                "f6": "b",
                "f7_f10": "    ",
                "f11_f14": "    ",
                "f15_f17": "|||",
                "f35_f37": "eng",
                "f38": " ",
                "f39": "d",
                "f18_f22": "|||||",
                "f23": " ",
                "f24_f34": "|||| 00|   "
            })
        }
        else if (materialType === "VM") {
            form.resetFields()
            form.setFieldsValue({
                "f0_f5": f0_f5,
                "f6": "b",
                "f7_f10": "    ",
                "f11_f14": "    ",
                "f15_f17": "|||",
                "f35_f37": "eng",
                "f38": " ",
                "f39": "d",
                "f18_f22": "|||||",
                "f23": " ",
                "f24_f34": "|||| 00|   ",
                "f18_f20": "|||",
                "f21": "|",
                "f22": "|",
                "f23_f27": " ||||",
                "f28": " ",
                "f29": " ",
                "f30_f32": "0| ",
                "f33": "a",
                "f34": "a"
            })
        }
    }
    //根據leader的值設定 material types
    const recordTypeDifferentiation = (leader) => {
        let leaderString = leader || ""
        let leaderArr = leaderString.split('')
        let leader06 = leaderArr?.[6]
        let leader07 = leaderArr?.[7]
        let materiaTypeTemp = "BKS"

        // Books （BK） 圖書 => Leader/06 = t OR Leader/06 = a and Leader/07 = a, c, d, or m
        if ((leader06 === "t") || (((leader06 === "a")) && (leader07 === "a" || leader07 === "c" || leader07 === "d" || leader07 === "m"))) {
            materiaTypeTemp = "BKS"
        }
        // Continuing Resources （CR）連續性出版品 =>Leader/06 = a and Leader/07 = b, i, or s
        else if (((leader06 === "a")) && (leader07 === "b" || leader07 === "i" || leader07 === "s")) {
            materiaTypeTemp = "CR"
        }
        // Music （MU） 音樂資料 => Leader/06 = c, d, i, or j 
        else if (((leader06 === "c" || leader06 === "d" || leader06 === "i" || leader06 === "j"))) {
            materiaTypeTemp = "MU"

        }
        // Maps （MP）地圖資料 => Leader/06 = e, or f
        else if (leader06 === "e" || leader06 === "f") {
            materiaTypeTemp = "MP"

        }
        // Visual Materials （VM） 視覺資料 => Leader/06 = g, k, o, or r
        else if (leader06 === "g" || leader06 === "k" || leader06 === "o" || leader06 === "r") {
            materiaTypeTemp = "VM"

        }
        // Mixed Materials （MX）混合型資料 => Leader/06 = p
        else if (leader06 === "p") {
            materiaTypeTemp = "MX"
        }
        console.log({
            leader06,
            leader07,
            materiaTypeTemp
        })
        setMaterialType((pre) => {
            console.log({
                temp :pre === materiaTypeTemp
            })
            if (pre === materiaTypeTemp) {
                changeMode.current = "leader"
            }
            else {
                changeMode.current = "select"
            }
            return materiaTypeTemp
        })
    }
    const getResult = (rules, tag008) => {
        let result = {};
        for (const [key, range] of Object.entries(rules)) {
            if (range.includes("-")) {
                const [start, end] = range.split("-").map(Number);
                result[key] = tag008.slice(start, end + 1);
            } else {
                const index = Number(range);
                result[key] = tag008[index];
            }
        }
        return result
    }
    const setTag008Value = (tag008, materialType) => {
        console.log({
            tag008
        })
        if (materialType === "BKS") {
            const rules = {
                "f0_f5": "0-5",
                "f6": "6",
                "f7_f10": "7-10",
                "f11_f14": "11-14",
                "f15_f17": "15-17",
                "f18": "18",
                "f19": "19",
                "f20": "20",
                "f21": "21",
                "f22": "22",
                "f23": "23",
                "f24": "24",
                "f25": "25",
                "f26": "26",
                "f27": "27",
                "f28": "28",
                "f29": "29",
                "f30": "30",
                "f31": "31",
                "f32": "32",
                "f33": "33",
                "f34": "34",
                "f35_f37": "35-37",
                "f38": "38",
                "f39": "39",
            };
            let tag = tag008 || ""
            let result = getResult(rules, tag)
            form.resetFields()
            console.log({
                result
            })
            form.setFieldsValue({
                ...result
            })
        }
        else if (materialType === "CF") {
            const rules = {
                "f0_f5": "0-5",
                "f6": "6",
                "f7_f10": "7-10",
                "f11_f14": "11-14",
                "f15_f17": "15-17",
                "f18_f21": "18-21",
                "f22": "22",
                "f23": "23",
                "f24_f25": "24-25",
                "f26": "26",
                "f27": "27",
                "f28": "28",
                "f29_f34": "29-34",
                "f35_f37": "35-37",
                "f38": "38",
                "f39": "39"
            };
            let tag = tag008 || ""
            let result = getResult(rules, tag)
            form.resetFields()
            form.setFieldsValue({
                ...result
            })
        }
        else if (materialType === "CR") {
            const rules = {
                "f0_f5": "0-5",
                "f6": "6",
                "f7_f10": "7-10",
                "f11_f14": "11-14",
                "f15_f17": "15-17",
                "f18": "18",
                "f19": "19",
                "f20": "20",
                "f21": "21",
                "f22": "22",
                "f23": "23",
                "f24": "24",
                "f25_f27": "25-27",
                "f28": "28",
                "f29": "29",
                "f30_f32": "30-32",
                "f33": "33",
                "f34": "34",
                "f35_f37": "35-37",
                "f38": "38",
                "f39": "39"
            };
            let tag = tag008 || ""
            let result = getResult(rules, tag)
            form.resetFields()
            form.setFieldsValue({
                ...result
            })
        }
        else if (materialType === "MP") {
            const rules = {
                "f0_f5": "0-5",
                "f6": "6",
                "f7_f10": "7-10",
                "f11_f14": "11-14",
                "f15_f17": "15-17",
                "f18_f21": "18-21",
                "f22_f23": "22-23",
                "f24": "24",
                "f25": "25",
                "f26_f27": "26-27",
                "f28": "28",
                "f29": "29",
                "f30": "30",
                "f31": "31",
                "f32": "32",
                "f33_f34": "33-34",
                "f35_f37": "35-37",
                "f38": "38",
                "f39": "39"
            };
            let tag = tag008 || ""
            let result = getResult(rules, tag)
            form.resetFields()
            form.setFieldsValue({
                ...result
            })
        }
        else if (materialType === "MU") {
            const rules = {
                "f0_f5": "0-5",
                "f6": "6",
                "f7_f10": "7-10",
                "f11_f14": "11-14",
                "f15_f17": "15-17",
                "f18_f19": "18-19",
                "f20": "20",
                "f21": "21",
                "f22": "22",
                "f23": "23",
                "f24_f29": "24-29",
                "f30_f31": "30-31",
                "f32": "32",
                "f33": "33",
                "f34": "34",
                "f35_f37": "35-37",
                "f38": "38",
                "f39": "39"
            };
            let tag = tag008 || ""
            let result = getResult(rules, tag)
            form.resetFields()
            form.setFieldsValue({
                ...result
            })
        }
        else if (materialType === "MX") {
            const rules = {
                "f0_f5": "0-5",
                "f6": "6",
                "f7_f10": "7-10",
                "f11_f14": "11-14",
                "f15_f17": "15-17",
                "f18_f22": "18-22",
                "f23": "23",
                "f24_f34": "24-34",
                "f35_f37": "35-37",
                "f38": "38",
                "f39": "39"
            };
            let tag = tag008 || ""
            let result = getResult(rules, tag)
            form.resetFields()
            form.setFieldsValue({
                ...result
            })
        }
        else if (materialType === "VM") {
            const rules = {
                "f0_f5": "0-5",
                "f6": "6",
                "f7_f10": "7-10",
                "f11_f14": "11-14",
                "f15_f17": "15-17",
                "f18_f22": "18-22",
                "f23": "23",
                "f24_f34": "24-34",
                "f35_f37": "35-37",
                "f38": "38",
                "f39": "39",
                "f18_f20": "18-20",
                "f21": "21",
                "f22": "22",
                "f23_f27": "23-27",
                "f28": "28",
                "f29": "29",
                "f30_f32": "30-32",
                "f33": "33",
                "f34": "34"
            };
            let tag = tag008 || ""
            let result = getResult(rules, tag)
            form.resetFields()
            form.setFieldsValue({
                ...result
            })

        }

    }
    useEffect(() => {
        if (tag008 && tag008.length === 40) {
            //根據不同的 material type 設定不同的008預設值
            setTag008Value(tag008, materialType)
        }
        else if (!tag008) {
            //根據不同的 material type 設定不同的008預設值
            setDifferent008DefaultValuesByDifferentMaterialTypes(materialType)
        }
    }, [tag008])
    useEffect(() => {
        recordTypeDifferentiation(leader)
    }, [leader])
    useEffect(() => {
        setDataInitialization();
    }, []);
    useEffect(() => {
        if (changeMode.current === "select") {
            setDifferent008DefaultValuesByDifferentMaterialTypes(materialType)
        }
        else if (changeMode.current === "leader") {

        }
    }, [materialType]);
    return (
        <Row>
            <Col span={24}>
                <Form
                    form={form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"

                >
                    <Row>
                        <Col span={24}>
                            <FormItemComponent
                                keyPrefix={keyPrefix}
                                field={field}
                                count={count}
                                setMaterialType={(value) => {
                                    changeMode.current = "select"
                                    setMaterialType(value)
                                }}
                                materialType={materialType}
                            />
                        </Col>
                    </Row>

                </Form >
            </Col >
        </Row >
    );
};
const FormItemComponent = ({
    keyPrefix = 'cataloging.AddMARC',
    field,
    initialValues = {},
    count,
    materialType,
    setMaterialType
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const materialOptions = [
        {
            label: "BKS - 書籍",
            value: "BKS",
        },
        {
            label: "CF - 電腦文件",
            value: "CF",
        },
        {
            label: "CR - 持續資源",
            value: "CR",
        },
        {
            label: "MP - 地圖",
            value: "MP",
        },
        {
            label: "MU - 音樂",
            value: "MU",
        },
        {
            label: "MX - 混合材料",
            value: "MX",
        },
        {
            label: "VM - 視覺材料",
            value: "VM",
        },
    ]
    const illustrationsOptions = [
        { value: "", label: "# - 無插圖" },
        { value: "a", label: "a - 插畫" },
        { value: "b", label: "b - 地圖" },
        { value: "c", label: "c - 肖像" },
        { value: "d", label: "d - 圖表" },
        { value: "e", label: "e - 電子計劃" },
        { value: "f", label: "f - 板" },
        { value: "g", label: "g - 音樂" },
        { value: "h", label: "h - 傳真" },
        { value: "i", label: "i - 徽章" },
        { value: "j", label: "j - 家譜表" },
        { value: "k", label: "k - 表格" },
        { value: "l", label: "l - 樣品" },
        { value: "m", label: "m - 唱盤、唱線等" },
        { value: "o", label: "o - 照片" },
        { value: "p", label: "p - 照明" },
        { value: "|", label: "| - 沒有嘗試編碼" }
    ]
    const targetAudienceOptions = [
        { value: " ", label: "# - 未知或未指定/Unknown or unspecified" },
        { value: "a", label: "a - 學前/Preschool" },
        { value: "b", label: "b - 小學/Primary" },
        { value: "c", label: "c - 少年/Pre-adolescent" },
        { value: "d", label: "d - 青少年/Adolescent" },
        { value: "e", label: "e - 成人/Adult" },
        { value: "f", label: "f - 專業/Specialized" },
        { value: "g", label: "g - 通用/General" },
        { value: "j", label: "j - 少兒/Juvenile" },
        { value: "|", label: "| - 未嘗試編碼/No attempt to code" },

    ]
    const formOfItemOptions = [
        { value: " ", label: "# - 以下皆否 / None of the following" },
        { value: "a", label: "a - 微型電影 / Microfilm" },
        { value: "b", label: "b - 微型片 / Microfiche" },
        { value: "c", label: "c - 微型不透明片 / Microopaque" },
        { value: "d", label: "d - 大字印刷 / Large print" },
        { value: "f", label: "f - 盲文 / Braille" },
        { value: "o", label: "o - 在線 / Online" },
        { value: "q", label: "q - 直接電子 / Direct electronic" },
        { value: "r", label: "r - 正常印刷復制 / Regular print reproduction" },
        { value: "s", label: "s - 電子 / Electronic" },
        { value: "|", label: "| - 無編碼嘗試 / No attempt to code" }
    ]

    const getField008Positions18to34FormItems = (material_type, count) => {

        if (material_type === "BKS") {
            return (
                <>
                    <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                        <Form.Item
                            {...field}
                            label={t('illustrations_code_1')}
                            name={[field?.name ?? '', 'f18']}
                            fieldKey={[field?.fieldKey ?? '', 'f18']}
                        >
                            <Select
                                options={illustrationsOptions}
                            />
                        </Form.Item>
                    </Col>
                    <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                        <Form.Item
                            {...field}
                            name={[field?.name ?? '', 'f19']}
                            fieldKey={[field?.fieldKey ?? '', 'f19']}
                            label={t('illustrations_code_2')}
                        >
                            <Select
                                options={illustrationsOptions}
                            />
                        </Form.Item>
                    </Col>
                    <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                        <Form.Item
                            {...field}
                            name={[field?.name ?? '', 'f20']}
                            fieldKey={[field?.fieldKey ?? '', 'f20']}
                            label={t('illustrations_code_3')}
                        >
                            <Select
                                options={illustrationsOptions}
                            />
                        </Form.Item>

                    </Col>
                    <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                        <Form.Item
                            {...field}
                            name={[field?.name ?? '', 'f21']}
                            fieldKey={[field?.fieldKey ?? '', 'f21']}
                            label={t('illustrations_code_4')}
                        >
                            <Select
                                options={illustrationsOptions}

                            />
                        </Form.Item>
                    </Col>
                    <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                        <Form.Item
                            label={t('target_audience')}
                            {...field}
                            name={[field?.name ?? '', 'f22']}
                            fieldKey={[field?.fieldKey ?? '', 'f22']}
                        >
                            <Select
                                options={targetAudienceOptions}
                            />
                        </Form.Item>
                    </Col>
                    <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                        <Form.Item
                            {...field}
                            name={[field?.name ?? '', 'f23']}
                            fieldKey={[field?.fieldKey ?? '', 'f23']}
                            label={t('form_of_item')}
                        >
                            <Select options={formOfItemOptions} />
                        </Form.Item>
                    </Col>
                    <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                        <Form.Item
                            {...field}
                            name={[field?.name ?? '', 'f24']}
                            fieldKey={[field?.fieldKey ?? '', 'f24']}
                            label={t('nature_of_contents_code_1')}
                        >
                            <Select options={[
                                { value: " ", label: "# - 沒有指定內容的性質" },
                                { value: "2", label: "2 - 單行本" },
                                { value: "5", label: "5 - 日曆" },
                                { value: "6", label: "6 - 漫畫/圖像小說" },
                                { value: "a", label: "a - 摘要/總結" },
                                { value: "b", label: "b - 參考書目" },
                                { value: "c", label: "c - 目錄" },
                                { value: "d", label: "d - 字典" },
                                { value: "e", label: "e - 電子百科全書" },
                                { value: "f", label: "f - 手冊" },
                                { value: "g", label: "g - 法律文章" },
                                { value: "i", label: "i - 索引" },
                                { value: "j", label: "j - 專利文件" },
                                { value: "k", label: "k - 唱片目錄" },
                                { value: "l", label: "l - 立法" },
                                { value: "m", label: "m - 論文" },
                                { value: "n", label: "n - 某一主題領域的文獻調查" },
                                { value: "o", label: "o - 評論" },
                                { value: "p", label: "p - 程式設計文本" },
                                { value: "q", label: "q - 電影年表" },
                                { value: "r", label: "r - 目錄" },
                                { value: "s", label: "s - 統計" },
                                { value: "t", label: "t - 技術報告" },
                                { value: "u", label: "u - 標準/規範" },
                                { value: "v", label: "v - 法律案例和案例說明" },
                                { value: "w", label: "w - 法律報告與摘要" },
                                { value: "y", label: "y - 年鑑" },
                                { value: "z", label: "z - 條約" },
                                { value: "|", label: "| - 沒有嘗試編碼" }
                            ]} />
                        </Form.Item>
                    </Col>
                    <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                        <Form.Item
                            label={t('nature_of_contents_code_2')}
                            {...field}
                            name={[field?.name ?? '', 'f25']}
                            fieldKey={[field?.fieldKey ?? '', 'f25']}

                        >
                            <Select
                                options={[
                                    { value: " ", label: "# - 沒有指定內容的性質" },
                                    { value: "2", label: "2 - 單行本" },
                                    { value: "5", label: "5 - 日曆" },
                                    { value: "6", label: "6 - 漫畫/圖像小說" },
                                    { value: "a", label: "a - 摘要/總結" },
                                    { value: "b", label: "b - 參考書目" },
                                    { value: "c", label: "c - 目錄" },
                                    { value: "d", label: "d - 字典" },
                                    { value: "e", label: "e - 電子百科全書" },
                                    { value: "f", label: "f - 手冊" },
                                    { value: "g", label: "g - 法律文章" },
                                    { value: "i", label: "i - 索引" },
                                    { value: "j", label: "j - 專利文件" },
                                    { value: "k", label: "k - 唱片目錄" },
                                    { value: "l", label: "l - 立法" },
                                    { value: "m", label: "m - 論文" },
                                    { value: "n", label: "n - 某一主題領域的文獻調查" },
                                    { value: "o", label: "o - 評論" },
                                    { value: "p", label: "p - 程式設計文本" },
                                    { value: "q", label: "q - 電影年表" },
                                    { value: "r", label: "r - 目錄" },
                                    { value: "s", label: "s - 統計" },
                                    { value: "t", label: "t - 技術報告" },
                                    { value: "u", label: "u - 標準/規範" },
                                    { value: "v", label: "v - 法律案例和案例說明" },
                                    { value: "w", label: "w - 法律報告與摘要" },
                                    { value: "y", label: "y - 年鑑" },
                                    { value: "z", label: "z - 條約" },
                                    { value: "|", label: "| - 沒有嘗試編碼" }
                                ]} />
                        </Form.Item>
                    </Col>
                    <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                        <Form.Item
                            {...field}
                            name={[field?.name ?? '', 'f26']}
                            fieldKey={[field?.fieldKey ?? '', 'f26']}
                            label={t('nature_of_contents_code_3')}
                        >
                            <Select
                                options={[
                                    { value: " ", label: "# - 沒有指定內容的性質" },
                                    { value: "2", label: "2 - 單行本" },
                                    { value: "5", label: "5 - 日曆" },
                                    { value: "6", label: "6 - 漫畫/圖像小說" },
                                    { value: "a", label: "a - 摘要/總結" },
                                    { value: "b", label: "b - 參考書目" },
                                    { value: "c", label: "c - 目錄" },
                                    { value: "d", label: "d - 字典" },
                                    { value: "e", label: "e - 電子百科全書" },
                                    { value: "f", label: "f - 手冊" },
                                    { value: "g", label: "g - 法律文章" },
                                    { value: "i", label: "i - 索引" },
                                    { value: "j", label: "j - 專利文件" },
                                    { value: "k", label: "k - 唱片目錄" },
                                    { value: "l", label: "l - 立法" },
                                    { value: "m", label: "m - 論文" },
                                    { value: "n", label: "n - 某一主題領域的文獻調查" },
                                    { value: "o", label: "o - 評論" },
                                    { value: "p", label: "p - 程式設計文本" },
                                    { value: "q", label: "q - 電影年表" },
                                    { value: "r", label: "r - 目錄" },
                                    { value: "s", label: "s - 統計" },
                                    { value: "t", label: "t - 技術報告" },
                                    { value: "u", label: "u - 標準/規範" },
                                    { value: "v", label: "v - 法律案例和案例說明" },
                                    { value: "w", label: "w - 法律報告與摘要" },
                                    { value: "y", label: "y - 年鑑" },
                                    { value: "z", label: "z - 條約" },
                                    { value: "|", label: "| - 沒有嘗試編碼" }
                                ]} />
                        </Form.Item>
                    </Col>
                    <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                        <Form.Item
                            {...field}
                            name={[field?.name ?? '', 'f27']}
                            fieldKey={[field?.fieldKey ?? '', 'f27']}
                            label={t('nature_of_contents_code_4')}
                        >
                            <Select
                                options={[
                                    { value: " ", label: "# - 沒有指定內容的性質" },
                                    { value: "2", label: "2 - 單行本" },
                                    { value: "5", label: "5 - 日曆" },
                                    { value: "6", label: "6 - 漫畫/圖像小說" },
                                    { value: "a", label: "a - 摘要/總結" },
                                    { value: "b", label: "b - 參考書目" },
                                    { value: "c", label: "c - 目錄" },
                                    { value: "d", label: "d - 字典" },
                                    { value: "e", label: "e - 電子百科全書" },
                                    { value: "f", label: "f - 手冊" },
                                    { value: "g", label: "g - 法律文章" },
                                    { value: "i", label: "i - 索引" },
                                    { value: "j", label: "j - 專利文件" },
                                    { value: "k", label: "k - 唱片目錄" },
                                    { value: "l", label: "l - 立法" },
                                    { value: "m", label: "m - 論文" },
                                    { value: "n", label: "n - 某一主題領域的文獻調查" },
                                    { value: "o", label: "o - 評論" },
                                    { value: "p", label: "p - 程式設計文本" },
                                    { value: "q", label: "q - 電影年表" },
                                    { value: "r", label: "r - 目錄" },
                                    { value: "s", label: "s - 統計" },
                                    { value: "t", label: "t - 技術報告" },
                                    { value: "u", label: "u - 標準/規範" },
                                    { value: "v", label: "v - 法律案例和案例說明" },
                                    { value: "w", label: "w - 法律報告與摘要" },
                                    { value: "y", label: "y - 年鑑" },
                                    { value: "z", label: "z - 條約" },
                                    { value: "|", label: "| - 沒有嘗試編碼" }
                                ]} />
                        </Form.Item>
                    </Col>
                    <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                        <Form.Item
                            {...field}
                            name={[field?.name ?? '', 'f28']}
                            fieldKey={[field?.fieldKey ?? '', 'f28']}
                            label={t('government_publication')}
                        >
                            <Select
                                options={[
                                    { value: " ", label: "# - 不是政府出版物" },
                                    { value: "a", label: "a - 自主或半自主組件" },
                                    { value: "c", label: "c - 多地方" },
                                    { value: "f", label: "f - 聯邦/國家" },
                                    { value: "i", label: "i - 國際政府間" },
                                    { value: "l", label: "l - 地方" },
                                    { value: "m", label: "m - 多州" },
                                    { value: "o", label: "o - 政府出版物級別未確定" },
                                    { value: "s", label: "s - 州、省、領土、依賴等" },
                                    { value: "u", label: "u - 不確定是否為政府出版物" },
                                    { value: "z", label: "z - 其他" },
                                    { value: "|", label: "| - 未嘗試編碼" }
                                ]} />
                        </Form.Item>
                    </Col>
                    <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                        <Form.Item
                            {...field}
                            name={[field?.name ?? '', 'f29']}
                            fieldKey={[field?.fieldKey ?? '', 'f29']}
                            label={t('conference_publication')}
                        >
                            <Select
                                options={[
                                    { value: "0", label: "0 - 不是會議出版物" },
                                    { value: "1", label: "1 - 會議出版物" },
                                    { value: "|", label: "| - 未嘗試編碼" }

                                ]} />
                        </Form.Item>

                    </Col>
                    <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                        <Form.Item
                            {...field}
                            name={[field?.name ?? '', 'f30']}
                            fieldKey={[field?.fieldKey ?? '', 'f30']}
                            label={t('festschrift')}
                        >
                            <Select
                                options={[
                                    { value: "0", label: "0 - 不是紀念文集" },
                                    { value: "1", label: "1 - 紀念文集" },
                                    { value: "|", label: "| - 未嘗試編碼" }
                                ]} />
                        </Form.Item>
                    </Col>
                    <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                        <Form.Item
                            {...field}
                            name={[field?.name ?? '', 'f31']}
                            fieldKey={[field?.fieldKey ?? '', 'f31']}
                            label={t('index')}
                        >
                            <Select
                                options={[
                                    { value: "0", label: "0 - 無索引" },
                                    { value: "1", label: "1 - 有索引" },
                                    { value: "|", label: "| - 未嘗試編碼" }
                                ]} />
                        </Form.Item>
                    </Col>
                    <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                        <Form.Item
                            {...field}
                            name={[field?.name ?? '', 'f32']}
                            fieldKey={[field?.fieldKey ?? '', 'f32']}
                            label={t('undefined')}                                    >
                            <Select
                                options={[
                                    { value: " ", label: "# - 包含空白 (#) 或填充字符 (|) /# - Contains a blank (#) or a fill character (|)" },
                                    { value: "|", label: "| - 包含空白 (#) 或填充字符 (|) /| - Contains a blank (#) or a fill character (|)" }
                                ]} />
                        </Form.Item>
                    </Col>
                    <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                        <Form.Item
                            {...field}
                            name={[field?.name ?? '', 'f33']}
                            fieldKey={[field?.fieldKey ?? '', 'f33']}
                            label={t('literary_form')}
                        >
                            <Select
                                options={[
                                    { value: "0", label: "0 - 非小說（未進一步說明）" },
                                    { value: "1", label: "1 - 小說（未進一步說明）" },
                                    { value: "d", label: "d - 戲劇" },
                                    { value: "e", label: "e - 隨筆" },
                                    { value: "f", label: "f - 小說" },
                                    { value: "h", label: "h - 幽默、諷刺等" },
                                    { value: "i", label: "i - 書信" },
                                    { value: "j", label: "j - 短篇小說" },
                                    { value: "m", label: "m - 混合形式" },
                                    { value: "p", label: "p - 詩歌" },
                                    { value: "s", label: "s - 演講" },
                                    { value: "u", label: "u - 未知" },
                                    { value: "|", label: "| - 未嘗試編碼" }
                                ]} />
                        </Form.Item>
                    </Col>
                    <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                        <Form.Item
                            {...field}
                            name={[field?.name ?? '', 'f34']}
                            fieldKey={[field?.fieldKey ?? '', 'f34']}
                            label={t('biography')}
                        >
                            <Select
                                options={[
                                    { value: " ", label: "# - 沒有傳記資料" },
                                    { value: "a", label: "a - 自傳" },
                                    { value: "b", label: "b - 個人傳記" },
                                    { value: "c", label: "c - 集體傳記" },
                                    { value: "d", label: "d - 包含傳記信息" },
                                    { value: "|", label: "| - 未嘗試編碼" }
                                ]} />
                        </Form.Item>
                    </Col>
                </>
            )
        }
        else if (material_type === "CF") {
            return (<>
                <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item
                        {...field}
                        label={t('undefined_18_21')}
                        name={[field?.name ?? '', 'f18_f21']}
                        fieldKey={[field?.fieldKey ?? '', 'f18_f21']}
                    >
                        <Input maxlength="4" />
                    </Form.Item>
                </Col>
                <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item
                        {...field}
                        name={[field?.name ?? '', 'f22']}
                        fieldKey={[field?.fieldKey ?? '', 'f22']}
                        label={t('target_audience_22')}
                    >
                        <Select
                            options={targetAudienceOptions}
                        />
                    </Form.Item>
                </Col>
                <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item
                        {...field}
                        name={[field?.name ?? '', 'f23']}
                        fieldKey={[field?.fieldKey ?? '', 'f23']}
                        label={t('form_of_item_23')}
                    >
                        <Select
                            options={[
                                { value: " ", label: "# - 未知或未指定 / # - Unknown or not specified" },
                                { value: "o", label: "o - 在線 / o - Online" },
                                { value: "q", label: "q - 直接電子 / q - Direct electronic" },
                                { value: "|", label: "| - 無編碼嘗試 / | - No attempt to code" }
                            ]}
                        />
                    </Form.Item>

                </Col>
                <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item
                        {...field}
                        name={[field?.name ?? '', 'f24_f25']}
                        fieldKey={[field?.fieldKey ?? '', 'f24_f25']}
                        label={t('undefined_24_25')}
                    >
                        <Input maxlength="2" />
                    </Form.Item>
                </Col>
                <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item
                        label={t('type_of_computer_file_26')}
                        {...field}
                        name={[field?.name ?? '', 'f26']}
                        fieldKey={[field?.fieldKey ?? '', 'f26']}
                    >
                        <Select
                            options={[
                                { value: "a", label: "a - 數字數據 / a - Numeric data" },
                                { value: "b", label: "b - 電腦程式 / b - Computer program" },
                                { value: "c", label: "c - 代表性資料 / c - Representational" },
                                { value: "d", label: "d - 文件 / d - Document" },
                                { value: "e", label: "e - 書目資料 / e - Bibliographic data" },
                                { value: "f", label: "f - 字型 / f - Font" },
                                { value: "g", label: "g - 遊戲 / g - Game" },
                                { value: "h", label: "h - 音頻 / h - Sound" },
                                { value: "i", label: "i - 互動多媒體 / i - Interactive multimedia" },
                                { value: "j", label: "j - 在線系統或服務 / j - Online system or service" },
                                { value: "m", label: "m - 組合 / m - Combination" },
                                { value: "u", label: "u - 未知 / u - Unknown" },
                                { value: "z", label: "z - 其他 / z - Other" },
                                { value: "|", label: "| - 無編碼嘗試 / | - No attempt to code" }
                            ]}
                        />
                    </Form.Item>
                </Col>
                <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item
                        {...field}
                        name={[field?.name ?? '', 'f27']}
                        fieldKey={[field?.fieldKey ?? '', 'f27']}
                        label={t('undefined_27')}
                    >
                        <Select options={[
                            { value: " ", label: "# - 一字符代碼，包含空白 (#) 或填充字符 (|) / # - One-character code that contains a blank (#) or a fill character (|)" },
                            { value: "|", label: "| - 一字符代碼，包含空白 (#) 或填充字符 (|) / | - One-character code that contains a blank (#) or a fill character (|)" }
                        ]} />
                    </Form.Item>
                </Col>
                <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item
                        {...field}
                        name={[field?.name ?? '', 'f28']}
                        fieldKey={[field?.fieldKey ?? '', 'f28']}
                        label={t('government_publication_28')}
                    >
                        <Select options={[
                            { value: " ", label: "# - 不是政府出版物 / # - Not a government publication" },
                            { value: "a", label: "a - 自治或半自治組件 / a - Autonomous or semi-autonomous component" },
                            { value: "c", label: "c - 多地點 / c - Multilocal" },
                            { value: "f", label: "f - 聯邦/國家 / f - Federal/national" },
                            { value: "i", label: "i - 國際政府間 / i - International intergovernmental" },
                            { value: "l", label: "l - 當地 / l - Local" },
                            { value: "m", label: "m - 多州 / m - Multistate" },
                            { value: "o", label: "o - 政府出版物級別未確定 / o - Government publication-level undetermined" },
                            { value: "s", label: "s - 州、省、領土、附屬等 / s - State, provincial, territorial, dependent, etc." },
                            { value: "u", label: "u - 不確定是否為政府出版物 / u - Unknown if item is government publication" },
                            { value: "z", label: "z - 其他 / z - Other" },
                            { value: "|", label: "| - 未嘗試編碼 / | - No attempt to code" }
                        ]} />
                    </Form.Item>
                </Col>
                <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item
                        label={t('undefined_29_34')}
                        {...field}
                        name={[field?.name ?? '', 'f29_f34']}
                        fieldKey={[field?.fieldKey ?? '', 'f29_f34']}

                    >
                        <Input maxlength="6" />
                    </Form.Item>
                </Col>
            </>)
        }
        else if (material_type === "CR") {
            return (<>
                <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item
                        {...field}
                        name={[field?.name ?? '', 'f18']}
                        fieldKey={[field?.fieldKey ?? '', 'f18']}
                        label={t('frequency_18')}
                    >
                        <Select options={[
                            { value: " ", label: "# - 無法確定頻率 / # - No determinable frequency" },
                            { value: "a", label: "a - 每年 / a - Annual" },
                            { value: "b", label: "b - 每兩個月 / b - Bimonthly" },
                            { value: "c", label: "c - 每週兩次 / c - Semiweekly" },
                            { value: "d", label: "d - 每天 / d - Daily" },
                            { value: "e", label: "e - 每兩週 / e - Biweekly" },
                            { value: "f", label: "f - 每半年 / f - Semiannual" },
                            { value: "g", label: "g - 每兩年 / g - Biennial" },
                            { value: "h", label: "h - 每三年 / h - Triennial" },
                            { value: "i", label: "i - 每週三次 / i - Three times a week" },
                            { value: "j", label: "j - 每月三次 / j - Three times a month" },
                            { value: "k", label: "k - 持續更新 / k - Continuously updated" },
                            { value: "m", label: "m - 每月 / m - Monthly" },
                            { value: "q", label: "q - 每季 / q - Quarterly" },
                            { value: "s", label: "s - 每月兩次 / s - Semimonthly" },
                            { value: "t", label: "t - 每年三次 / t - Three times a year" },
                            { value: "u", label: "u - 不確定 / u - Unknown" },
                            { value: "w", label: "w - 每週 / w - Weekly" },
                            { value: "z", label: "z - 其他 / z - Other" },
                            { value: "|", label: "| - 未嘗試編碼 / | - No attempt to code" }
                        ]} />
                    </Form.Item>
                </Col>
                <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item
                        label={t('regularity_19')}
                        {...field}
                        name={[field?.name ?? '', 'f19']}
                        fieldKey={[field?.fieldKey ?? '', 'f19']}

                    >
                        <Select options={[
                            { value: "n", label: "n - 正常化不規則 / Normalized irregular" },
                            { value: "r", label: "r - 正常 / Regular" },
                            { value: "u", label: "u - 不確定 / Unknown" },
                            { value: "x", label: "x - 完全不規則 / Completely irregular" },
                            { value: "|", label: "| - 未嘗試編碼 / No attempt to code" }
                        ]} />
                    </Form.Item>
                </Col>
                <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item
                        label={t('undefined_20')}
                        {...field}
                        name={[field?.name ?? '', 'f20']}
                        fieldKey={[field?.fieldKey ?? '', 'f20']}

                    >
                        <Select options={[
                            { value: " ", label: "# - 未定義；包含空白 (#) 或填充字符 (|) / Undefined; contains a blank (#) or a fill character (|)" },
                            { value: "|", label: "| - 未定義；包含空白 (#) 或填充字符 (|) / Undefined; contains a blank (#) or a fill character (|)" }
                        ]} />
                    </Form.Item>
                </Col>
                <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item
                        {...field}
                        name={[field?.name ?? '', 'f21']}
                        fieldKey={[field?.fieldKey ?? '', 'f21']}
                        label={t('type_of_continuing_resource_21')}
                    >
                        <Select options={[
                            { value: " ", label: "# - 其他無法定義 / None of the following" },
                            { value: "d", label: "d - 更新資料庫 / Updating database" },
                            { value: "g", label: "g - 雜誌 / Magazine" },
                            { value: "h", label: "h - 部落格 / Blog" },
                            { value: "j", label: "j - 期刊 / Journal" },
                            { value: "l", label: "l - 更新活頁 / Updating loose-leaf" },
                            { value: "m", label: "m - 單篇專題系列 / Monographic series" },
                            { value: "n", label: "n - 報紙 / Newspaper" },
                            { value: "p", label: "p - 期刊 / Periodical" },
                            { value: "r", label: "r - 資料庫 / Repository" },
                            { value: "s", label: "s - 新聞稿 / Newsletter" },
                            { value: "t", label: "t - 目錄 / Directory" },
                            { value: "w", label: "w - 更新網站 / Updating Web site" },
                            { value: "|", label: "| - 無編碼嘗試 / No attempt to code" }
                        ]} />
                    </Form.Item>
                </Col>
                <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item
                        {...field}
                        name={[field?.name ?? '', 'f22']}
                        fieldKey={[field?.fieldKey ?? '', 'f22']}
                        label={t('form_of_original_item_22')}
                    >
                        <Select options={[
                            { value: " ", label: "# - 其他無法定義 / None of the following" },
                            { value: "a", label: "a - 微型電影 / Microfilm" },
                            { value: "b", label: "b - 微型片 / Microfiche" },
                            { value: "c", label: "c - 微型不透明片 / Microopaque" },
                            { value: "d", label: "d - 大字印刷 / Large print" },
                            { value: "e", label: "e - 報紙格式 / Newspaper format" },
                            { value: "f", label: "f - 盲文 / Braille" },
                            { value: "o", label: "o - 在線 / Online" },
                            { value: "q", label: "q - 直接電子 / Direct electronic" },
                            { value: "s", label: "s - 電子 / Electronic" },
                            { value: "|", label: "| - 無編碼嘗試 / No attempt to code" }
                        ]} />
                    </Form.Item>
                </Col>
                <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item
                        {...field}
                        name={[field?.name ?? '', 'f23']}
                        fieldKey={[field?.fieldKey ?? '', 'f23']}
                        label={t('form_of_item_23')}
                    >
                        <Select
                            options={formOfItemOptions}
                        />
                    </Form.Item>

                </Col>
                <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item
                        {...field}
                        name={[field?.name ?? '', 'f24']}
                        fieldKey={[field?.fieldKey ?? '', 'f24']}
                        label={t('nature_of_entire_work_24')}
                    >
                        <Select
                            options={[
                                { value: " ", label: "# - 未指定 / Not specified" },
                                { value: "5", label: "5 - 日曆 / Calendars" },
                                { value: "6", label: "6 - 漫畫 / Comics/graphic novels" },
                                { value: "a", label: "a - 摘要 / Abstracts/summaries" },
                                { value: "b", label: "b - 參考書目 / Bibliographies" },
                                { value: "c", label: "c - 目錄 / Catalogs" },
                                { value: "d", label: "d - 字典 / Dictionaries" },
                                { value: "e", label: "e - 百科全書 / Encyclopedias" },
                                { value: "f", label: "f - 手冊 / Handbooks" },
                                { value: "g", label: "g - 法律文章 / Legal articles" },
                                { value: "h", label: "h - 傳記 / Biography" },
                                { value: "i", label: "i - 索引 / Indexes" },
                                { value: "k", label: "k - 唱片目錄 / Discographies" },
                                { value: "l", label: "l - 法律條文 / Legislation" },
                                { value: "m", label: "m - 論文 / Theses" },
                                { value: "n", label: "n - 主題領域文獻調查 / Surveys of literature in a subject area" },
                                { value: "o", label: "o - 書評 / Reviews" },
                                { value: "p", label: "p - 程式文本 / Programmed texts" },
                                { value: "q", label: "q - 影片目錄 / Filmographies" },
                                { value: "r", label: "r - 目錄 / Directories" },
                                { value: "s", label: "s - 統計數據 / Statistics" },
                                { value: "t", label: "t - 技術報告 / Technical reports" },
                                { value: "u", label: "u - 標準 / Standards/specifications" },
                                { value: "v", label: "v - 法律案例與案例註解 / Legal cases and case notes" },
                                { value: "w", label: "w - 法律報告與摘要 / Law reports and digests" },
                                { value: "y", label: "y - 年鑑 / Yearbooks" },
                                { value: "z", label: "z - 條約 / Treaties" },
                                { value: "|", label: "| - 無編碼嘗試 / No attempt to code" }
                            ]}
                        />
                    </Form.Item>
                </Col>
                <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item
                        label={t('nature_of_contents_25_27')}
                        {...field}
                        name={[field?.name ?? '', 'f25_f27']}
                        fieldKey={[field?.fieldKey ?? '', 'f25_f27']}
                    >
                        <Input maxlength="3" />
                    </Form.Item>
                </Col>
                <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item
                        {...field}
                        name={[field?.name ?? '', 'f28']}
                        fieldKey={[field?.fieldKey ?? '', 'f28']}
                        label={t('government_publication_28')}
                    >
                        <Select options={[
                            { value: " ", label: "# - 非政府出版物 / Not a government publication" },
                            { value: "a", label: "a - 自治或半自治組件 / Autonomous or semi-autonomous component" },
                            { value: "c", label: "c - 多地區 / Multilocal" },
                            { value: "f", label: "f - 聯邦/國家 / Federal/national" },
                            { value: "i", label: "i - 國際政府間 / International intergovernmental" },
                            { value: "l", label: "l - 當地 / Local" },
                            { value: "m", label: "m - 多州 / Multistate" },
                            { value: "o", label: "o - 政府出版物級別未確定 / Government publication-level undetermined" },
                            { value: "s", label: "s - 州、省、領土、依賴地等 / State, provincial, territorial, dependent, etc." },
                            { value: "u", label: "u - 無法確定是否為政府出版物 / Unknown if item is government publication" },
                            { value: "z", label: "z - 其他 / Other" },
                            { value: "|", label: "| - 無編碼嘗試 / No attempt to code" }
                        ]} />
                    </Form.Item>
                </Col>
                <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item
                        {...field}
                        name={[field?.name ?? '', 'f29']}
                        fieldKey={[field?.fieldKey ?? '', 'f29']}
                        label={t('conference_publication_29')}
                    >
                        <Select options={[
                            { value: "0", label: "0 - 非會議出版物 / Not a conference publication" },
                            { value: "1", label: "1 - 會議出版物 / Conference publication" },
                            { value: "|", label: "| - 無編碼嘗試 / No attempt to code" }
                        ]} />
                    </Form.Item>
                </Col>
                <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item
                        label={t('undefined_30_32')}
                        {...field}
                        name={[field?.name ?? '', 'f30_f32']}
                        fieldKey={[field?.fieldKey ?? '', 'f30_f32']}

                    >
                        <Input maxlength="3" />
                    </Form.Item>
                </Col>
                <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item
                        {...field}
                        name={[field?.name ?? '', 'f33']}
                        fieldKey={[field?.fieldKey ?? '', 'f33']}
                        label={t('original_alphabet_or_script_of_title_33')}
                    >
                        <Select options={[
                            { value: " ", label: "# - 未提供字母或文字系統/無關鍵標題 - No alphabet or script given/No key title" },
                            { value: "a", label: "a - 基本羅馬字母 - Basic Roman" },
                            { value: "b", label: "b - 擴展羅馬字母 - Extended Roman" },
                            { value: "c", label: "c - 西里爾字母 - Cyrillic" },
                            { value: "d", label: "d - 日文 - Japanese" },
                            { value: "e", label: "e - 中文 - Chinese" },
                            { value: "f", label: "f - 阿拉伯文 - Arabic" },
                            { value: "g", label: "g - 希臘文 - Greek" },
                            { value: "h", label: "h - 希伯來文 - Hebrew" },
                            { value: "i", label: "i - 泰文 - Thai" },
                            { value: "j", label: "j - 梵文 - Devanagari" },
                            { value: "k", label: "k - 韓文 - Korean" },
                            { value: "l", label: "l - 泰米爾文 - Tamil" },
                            { value: "u", label: "u - 未知 - Unknown" },
                            { value: "z", label: "z - 其他 - Other" },
                            { value: "|", label: "| - 無法編碼 - No attempt to code" }
                        ]} />
                    </Form.Item>
                </Col>
                <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item
                        {...field}
                        name={[field?.name ?? '', 'f34']}
                        fieldKey={[field?.fieldKey ?? '', 'f34']}
                        label={t('entry_convention_34')}
                    >
                        <Select options={[
                            { value: "0", label: "0 - 非會議出版物 / Not a conference publication" },
                            { value: "1", label: "1 - 會議出版物 / Conference publication" },
                            { value: "|", label: "| - 無編碼嘗試 / No attempt to code" }
                        ]} />
                    </Form.Item>
                </Col>
            </>)
        }
        else if (material_type === "MP") {
            return (<>
                <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item
                        {...field}
                        name={[field?.name ?? '', 'f18_f21']}
                        fieldKey={[field?.fieldKey ?? '', 'f18_f21']}
                        label={t('relief_18_21')}
                    >
                        <Input maxlength={'4'} />
                    </Form.Item>
                </Col>
                <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item
                        label={t('projection_22_23')}
                        {...field}
                        name={[field?.name ?? '', 'f22_f23']}
                        fieldKey={[field?.fieldKey ?? '', 'f22_f23']}

                    >
                        <Input maxlength={'2'} />
                    </Form.Item>
                </Col>
                <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item
                        {...field}
                        name={[field?.name ?? '', 'f24']}
                        fieldKey={[field?.fieldKey ?? '', 'f24']}
                        label={t('undefined_24')}
                    >
                        <Select options={[
                            { value: "", label: "# - 未定義；包含空白 (#) 或填充字符 (|)。 /# - Undefined; contains a blank (#) or a fill character (|)." },
                            { value: "|", label: "| - 未定義；包含空白 (#) 或填充字符 (|)。 /| - Undefined; contains a blank (#) or a fill character (|)." }
                        ]} />
                    </Form.Item>
                </Col>
                <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item
                        label={t('type_of_cartographic_material_25')}
                        {...field}
                        name={[field?.name ?? '', 'f25']}
                        fieldKey={[field?.fieldKey ?? '', 'f25']}

                    >
                        <Select options={[
                            { value: "a", label: "a - 單一地圖 /a - Single map" },
                            { value: "b", label: "b - 地圖系列 /b - Map series" },
                            { value: "c", label: "c - 地圖期刊 /c - Map serial" },
                            { value: "d", label: "d - 地球儀 /d - Globe" },
                            { value: "e", label: "e - 地圖集 /e - Atlas" },
                            { value: "f", label: "f - 另附於其他作品的單獨補充材料 /f - Separate supplement to another work" },
                            { value: "g", label: "g - 綁定於其他作品中的一部分 /g - Bound as part of another work" },
                            { value: "u", label: "u - 未知 /u - Unknown" },
                            { value: "z", label: "z - 其他 /z - Other" },
                            { value: "|", label: "| - 沒有嘗試編碼 /| - No attempt to code" }
                        ]} />
                    </Form.Item>
                </Col>
                <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item
                        {...field}
                        name={[field?.name ?? '', 'f26_f27']}
                        fieldKey={[field?.fieldKey ?? '', 'f26_f27']}
                        label={t('undefined_26_27')}
                    >
                        <Input />
                    </Form.Item>
                </Col>
                <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item
                        {...field}
                        name={[field?.name ?? '', 'f28']}
                        fieldKey={[field?.fieldKey ?? '', 'f28']}
                        label={t('government_publication_28')}
                    >
                        <Select options={[
                            { value: " ", label: "# - 非政府出版物 / Not a government publication" },
                            { value: "a", label: "a - 自治或半自治組件 / Autonomous or semi-autonomous component" },
                            { value: "c", label: "c - 多地區 / Multilocal" },
                            { value: "f", label: "f - 聯邦/國家 / Federal/national" },
                            { value: "i", label: "i - 國際政府間 / International intergovernmental" },
                            { value: "l", label: "l - 當地 / Local" },
                            { value: "m", label: "m - 多州 / Multistate" },
                            { value: "o", label: "o - 政府出版物級別未確定 / Government publication-level undetermined" },
                            { value: "s", label: "s - 州、省、領土、依賴地等 / State, provincial, territorial, dependent, etc." },
                            { value: "u", label: "u - 無法確定是否為政府出版物 / Unknown if item is government publication" },
                            { value: "z", label: "z - 其他 / Other" },
                            { value: "|", label: "| - 無編碼嘗試 / No attempt to code" }
                        ]} />
                    </Form.Item>
                </Col>
                <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item
                        {...field}
                        name={[field?.name ?? '', 'f29']}
                        fieldKey={[field?.fieldKey ?? '', 'f29']}
                        label={t('form_of_item_29')}
                    >
                        <Select
                            options={formOfItemOptions} />
                    </Form.Item>
                </Col>
                <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item
                        {...field}
                        name={[field?.name ?? '', 'f30']}
                        fieldKey={[field?.fieldKey ?? '', 'f30']}
                        label={t('undefined_30')}
                    >
                        <Select
                            options={[
                                { value: " ", label: "# - 包含空白 (#) 或填充字符 (|) /# - Contains a blank (#) or a fill character (|)" },
                                { value: "|", label: "| - 包含空白 (#) 或填充字符 (|) /| - Contains a blank (#) or a fill character (|)" }
                            ]}
                        />
                    </Form.Item>

                </Col>
                <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item
                        {...field}
                        name={[field?.name ?? '', 'f31']}
                        fieldKey={[field?.fieldKey ?? '', 'f31']}
                        label={t('index_31')}
                    >
                        <Select
                            options={[
                                { value: "0", label: "0 - 無索引 /0 - No index" },
                                { value: "1", label: "1 - 有索引 /1 - Index present" },
                                { value: "|", label: "| - 未嘗試編碼 /| - No attempt to code" }
                            ]}
                        />
                    </Form.Item>
                </Col>
                <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item
                        label={t('undefined_32')}
                        {...field}
                        name={[field?.name ?? '', 'f32']}
                        fieldKey={[field?.fieldKey ?? '', 'f32']}
                    >
                        <Select
                            options={[
                                { value: " ", label: "# - 包含空白 (#) 或填充字符 (|) /# - Contains a blank (#) or a fill character (|)" },
                                { value: "|", label: "| - 包含空白 (#) 或填充字符 (|) /| - Contains a blank (#) or a fill character (|)" }
                            ]}
                        />
                    </Form.Item>
                </Col>
                <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item
                        {...field}
                        name={[field?.name ?? '', 'f33_f34']}
                        fieldKey={[field?.fieldKey ?? '', 'f33_f34']}
                        label={t('special_format_characteristics_33_34')}
                    >
                        <Input maxlength="2" />
                    </Form.Item>
                </Col>
            </>)
        }
        else if (material_type === "MU") {
            return (<>
                <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item
                        {...field}
                        name={[field?.name ?? '', 'f18_f19']}
                        fieldKey={[field?.fieldKey ?? '', 'f18_f19']}
                        label={t('form_of_composition_18_19')}
                    >
                        <Input maxlength={'2'} />
                    </Form.Item>
                </Col>
                <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item
                        label={t('format_of_music_20')}
                        {...field}
                        name={[field?.name ?? '', 'f20']}
                        fieldKey={[field?.fieldKey ?? '', 'f20']}
                    >
                        <Select options={[
                            { value: "a", label: "a - 滿分 /a - Full score" },
                            { value: "b", label: "b - 微型或研究尺寸 /b - Miniature or study size" },
                            { value: "c", label: "c - 鍵盤伴奏減少 /c - Accompaniment reduced for keyboard" },
                            { value: "d", label: "d - 省略伴奏的聲樂樂譜 /d - Voice score with accompaniment omitted" },
                            { value: "e", label: "e - 壓縮樂譜或鋼琴指揮樂譜 /e - Condensed score or piano-conductor score" },
                            { value: "g", label: "g - 接近分數 /g - Close score" },
                            { value: "h", label: "h - 合唱樂譜 /h - Chorus score" },
                            { value: "i", label: "i - 壓縮分數 /i - Condensed score" },
                            { value: "j", label: "j - 表演者-指揮部分 /j - Performer-conductor part" },
                            { value: "k", label: "k - 聲樂分數 /k - Vocal score" },
                            { value: "l", label: "l - 分數 /l - Score" },
                            { value: "m", label: "m - 多種樂譜格式 /m - Multiple score formats" },
                            { value: "n", label: "n - 不適用 /n - Not applicable" },
                            { value: "p", label: "p - 鋼琴譜 /p - Piano score" },
                            { value: "u", label: "u - 未知 /u - Unknown" },
                            { value: "z", label: "z - 其他 /z - Other" },
                            { value: "|", label: "| - 沒有嘗試編碼 /| - No attempt to code" }
                        ]} />
                    </Form.Item>
                </Col>
                <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item
                        {...field}
                        name={[field?.name ?? '', 'f21']}
                        fieldKey={[field?.fieldKey ?? '', 'f21']}
                        label={t('music_parts_21')}
                    >
                        <Select options={[
                            { value: "", label: "# - No parts in hand or not specified" },
                            { value: "d", label: "d - Instrumental and vocal parts" },
                            { value: "e", label: "e - Instrumental parts" },
                            { value: "f", label: "f - Vocal parts" },
                            { value: "n", label: "n - Not applicable" },
                            { value: "u", label: "u - Unknown" },
                            { value: "|", label: "| - No attempt to code" }
                        ]} />
                    </Form.Item>
                </Col>
                <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item
                        label={t('target_audience_22')}
                        {...field}
                        name={[field?.name ?? '', 'f22']}
                        fieldKey={[field?.fieldKey ?? '', 'f22']}

                    >
                        <Select options={targetAudienceOptions} />
                    </Form.Item>
                </Col>
                <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item
                        {...field}
                        name={[field?.name ?? '', 'f23']}
                        fieldKey={[field?.fieldKey ?? '', 'f23']}
                        label={t('form_of_item_23')}
                    >
                        <Select options={formOfItemOptions} />
                    </Form.Item>
                </Col>
                <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item
                        {...field}
                        name={[field?.name ?? '', 'f24_f29']}
                        fieldKey={[field?.fieldKey ?? '', 'f24_f29']}
                        label={t('accompanying_matter_24_29')}
                    >
                        <Input maxlength="6" />
                    </Form.Item>
                </Col>
                <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item
                        {...field}
                        name={[field?.name ?? '', 'f30_f31']}
                        fieldKey={[field?.fieldKey ?? '', 'f30_f31']}
                        label={t('literary_text_for_sound_recordings_30_31')}
                    >
                        <Input maxlength="2" />
                    </Form.Item>
                </Col>
                <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item
                        {...field}
                        name={[field?.name ?? '', 'f32']}
                        fieldKey={[field?.fieldKey ?? '', 'f32']}
                        label={t('undefined_32')}
                    >
                        <Select
                            options={[
                                { value: " ", label: "# - 不明確的;包含空格 (#) 或填滿字元 (|)" },
                                { value: "|", label: "| - Undefined; contains a blank (#) or a fill character (|)" }
                            ]}
                        />
                    </Form.Item>

                </Col>
                <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item
                        {...field}
                        name={[field?.name ?? '', 'f33']}
                        fieldKey={[field?.fieldKey ?? '', 'f33']}
                        label={t('transposition_and_arrangement_33')}
                    >
                        <Select
                            options={[
                                { value: "", label: "# - Not arrangement or transposition or not specified" },
                                { value: "a", label: "a - Transposition" },
                                { value: "b", label: "b - Arrangement" },
                                { value: "c", label: "c - Both transposed and arranged" },
                                { value: "n", label: "n - Not applicable" },
                                { value: "u", label: "u - Unknown" },
                                { value: "|", label: "| - No attempt to code" }
                            ]}
                        />
                    </Form.Item>
                </Col>
                <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item
                        label={t('undefined_34')}
                        {...field}
                        name={[field?.name ?? '', 'f34']}
                        fieldKey={[field?.fieldKey ?? '', 'f34']}
                    >
                        <Select
                            options={[
                                { value: "", label: "# - Undefined; contains a blank (#) or a fill character (|)." },
                                { value: "|", label: "| - Undefined; contains a blank (#) or a fill character (|)." }
                            ]}
                        />
                    </Form.Item>
                </Col>

            </>)
        }
        else if (material_type === "MX") {
            return (<>
                <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item
                        {...field}
                        name={[field?.name ?? '', 'f18_f22']}
                        fieldKey={[field?.fieldKey ?? '', 'f18_f22']}
                        label={t('undefined_18_22')}
                    >
                        <Input maxlength={'5'} />
                    </Form.Item>
                </Col>
                <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item
                        {...field}
                        name={[field?.name ?? '', 'f23']}
                        fieldKey={[field?.fieldKey ?? '', 'f23']}
                        label={t('form_of_item_23')}
                    >
                        <Select options={formOfItemOptions} />
                    </Form.Item>
                </Col>
                <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item
                        {...field}
                        name={[field?.name ?? '', 'f24_f34']}
                        fieldKey={[field?.fieldKey ?? '', 'f24_f34']}
                        label={t('undefined_24_34')}
                    >
                        <Input maxlength="11" />
                    </Form.Item>
                </Col>
            </>)
        }
        else if (material_type === "VM") {
            return (<>
                <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item
                        {...field}
                        name={[field?.name ?? '', 'f18_f20']}
                        fieldKey={[field?.fieldKey ?? '', 'f18_f20']}
                        label={t('running_time_18_20')}
                    >
                        <Input maxlength={'3'} />
                    </Form.Item>
                </Col>
                <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item
                        {...field}
                        name={[field?.name ?? '', 'f21']}
                        fieldKey={[field?.fieldKey ?? '', 'f21']}
                        label={t('undefined_21')}
                    >
                        <Select options={[
                            { value: "", label: "# - Undefined; contains a blank (#) or a fill character (|)." },
                            { value: "|", label: "| - Undefined; contains a blank (#) or a fill character (|)." }
                        ]} />
                    </Form.Item>
                </Col>
                <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item
                        label={t('target_audience_22')}
                        {...field}
                        name={[field?.name ?? '', 'f22']}
                        fieldKey={[field?.fieldKey ?? '', 'f22']}

                    >
                        <Select options={targetAudienceOptions} />
                    </Form.Item>
                </Col>
                <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item
                        {...field}
                        name={[field?.name ?? '', 'f23_f27']}
                        fieldKey={[field?.fieldKey ?? '', 'f23_f27']}
                        label={t('undefined_23_27')}
                    >
                        <Input maxlength={'5'} />
                    </Form.Item>
                </Col>
                <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item
                        {...field}
                        name={[field?.name ?? '', 'f28']}
                        fieldKey={[field?.fieldKey ?? '', 'f28']}
                        label={t('government_publication_28')}
                    >
                        <Select options={[
                            { value: " ", label: "# - 非政府出版物 / Not a government publication" },
                            { value: "a", label: "a - 自治或半自治組件 / Autonomous or semi-autonomous component" },
                            { value: "c", label: "c - 多地區 / Multilocal" },
                            { value: "f", label: "f - 聯邦/國家 / Federal/national" },
                            { value: "i", label: "i - 國際政府間 / International intergovernmental" },
                            { value: "l", label: "l - 當地 / Local" },
                            { value: "m", label: "m - 多州 / Multistate" },
                            { value: "o", label: "o - 政府出版物級別未確定 / Government publication-level undetermined" },
                            { value: "s", label: "s - 州、省、領土、依賴地等 / State, provincial, territorial, dependent, etc." },
                            { value: "u", label: "u - 無法確定是否為政府出版物 / Unknown if item is government publication" },
                            { value: "z", label: "z - 其他 / Other" },
                            { value: "|", label: "| - 無編碼嘗試 / No attempt to code" }
                        ]} />
                    </Form.Item>
                </Col>
                <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item
                        {...field}
                        name={[field?.name ?? '', 'f29']}
                        fieldKey={[field?.fieldKey ?? '', 'f29']}
                        label={t('form_of_item_29')}
                    >
                        <Select
                            options={[
                                { value: " ", label: "# - 以下皆非 /# - None of the following" },
                                { value: "a", label: "a - 微型膠卷 /a - Microfilm" },
                                { value: "b", label: "b - 微型膠片 /b - Microfiche" },
                                { value: "c", label: "c - 微型不透明片 /c - Microopaque" },
                                { value: "d", label: "d - 大字版 /d - Large print" },
                                { value: "f", label: "f - 盲文 /f - Braille" },
                                { value: "o", label: "o - 在線 /o - Online" },
                                { value: "q", label: "q - 直接電子版 /q - Direct electronic" },
                                { value: "r", label: "r - 常規印刷複製 /r - Regular print reproduction" },
                                { value: "s", label: "s - 電子版 / s - Electronic" },
                                { value: "|", label: "| - 沒有嘗試編碼 / | - No attempt to code" }
                            ]} />
                    </Form.Item>
                </Col>
                <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item
                        label={t('undefined_30_32')}
                        {...field}
                        name={[field?.name ?? '', 'f30_f32']}
                        fieldKey={[field?.fieldKey ?? '', 'f30_f32']}
                    >
                        <Input maxlength="3" />
                    </Form.Item>
                </Col>
                <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item
                        {...field}
                        name={[field?.name ?? '', 'f33']}
                        fieldKey={[field?.fieldKey ?? '', 'f33']}
                        label={t('type_of_visual_material_33')}
                    >
                        <Select
                            options={[
                                { value: "a", label: "a - 藝術原作 - Art original" },
                                { value: "b", label: "b - 套件 - Kit" },
                                { value: "c", label: "c - 藝術複製品 - Art reproduction" },
                                { value: "d", label: "d - 立體模型 - Diorama" },
                                { value: "f", label: "f - 幻燈片 - Filmstrip" },
                                { value: "g", label: "g - 遊戲 - Game" },
                                { value: "i", label: "i - 圖片 - Picture" },
                                { value: "k", label: "k - 圖形 - Graphic" },
                                { value: "l", label: "l - 技術圖 - Technical drawing" },
                                { value: "m", label: "m - 電影 - Motion picture" },
                                { value: "n", label: "n - 圖表 - Chart" },
                                { value: "o", label: "o - 閃卡 - Flash card" },
                                { value: "p", label: "p - 顯微鏡幻燈片 - Microscope slide" },
                                { value: "q", label: "q - 模型 - Model" },
                                { value: "r", label: "r - 實物 - Realia" },
                                { value: "s", label: "s - 幻燈片 - Slide" },
                                { value: "t", label: "t - 投影片 - Transparency" },
                                { value: "v", label: "v - 影音記錄 - Videorecording" },
                                { value: "w", label: "w - 玩具 - Toy" },
                                { value: "z", label: "z - 其他 - Other" },
                                { value: "|", label: "| - 無法編碼 - No attempt to code" }
                            ]}
                        />
                    </Form.Item>
                </Col>
                <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item
                        label={t('technique_34')}
                        {...field}
                        name={[field?.name ?? '', 'f34']}
                        fieldKey={[field?.fieldKey ?? '', 'f34']}
                    >
                        <Select
                            options={[
                                { value: "a", label: "a - 動畫 - Animation" },
                                { value: "c", label: "c - 動畫與實景 - Animation and live action" },
                                { value: "l", label: "l - 實景 - Live action" },
                                { value: "n", label: "n - 不適用 - Not applicable" },
                                { value: "u", label: "u - 未知 - Unknown" },
                                { value: "z", label: "z - 其他 - Other" },
                                { value: "|", label: "| - 無法編碼 - No attempt to code" }
                            ]}
                        />
                    </Form.Item>
                </Col>

            </>)
        }

    }


    return (
        <Row gutter={[4, 4]}>
            <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                <Row align="middle">
                    <Col span={8}>
                        <Row jusitfy="end">
                            <Col>
                                {t('type_of_material')}:
                            </Col>
                        </Row>
                    </Col>

                    <Col span={16}>
                        <Select
                            defaultValue={materialOptions.find((option) => option?.value === materialType)}
                            value={materialOptions.find((option) => option?.value === materialType)}
                            onChange={(val) => {
                                setMaterialType(val)
                            }}
                            options={materialOptions}
                        />
                    </Col>
                </Row>

            </Col>
            <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                <Form.Item
                    label={t('date_entered_on_file')}
                    {...field}
                    name={[field?.name ?? '', 'f0_f5']}
                    fieldKey={[field?.fieldKey ?? '', 'f0_f5']}
                >
                    <Input maxlength={"6"} placeholder="yymmdd" />
                </Form.Item>
            </Col>
            <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                <Form.Item
                    label={t('type_of_date_publication_status')}
                    {...field}
                    name={[field?.name ?? '', 'f6']}
                    fieldKey={[field?.fieldKey ?? '', 'f6']}
                >
                    <Select
                        options={[
                            { value: "b", label: "b - 沒有給出日期；涉及 BC 日期" },
                            { value: "c", label: "c - 連續性出版品仍刊行)" },
                            { value: "d", label: "d - 連續性出版品已停刊" },
                            { value: "e", label: "e - 詳細日期" },
                            { value: "i", label: "i - 包含收集日期" },
                            { value: "k", label: "k - 大量收集的年份範圍" },
                            { value: "m", label: "m - 多出版年" },
                            { value: "n", label: "n - 日期未知" },
                            { value: "p", label: "p - 分發/發布/發行和製作/錄製會話的日期不同時" },
                            { value: "q", label: "q - 版年不確定" },
                            { value: "r", label: "r - 重印/重新發行日期和原始日期" },
                            { value: "s", label: "s - 單一出版年" },
                            { value: "t", label: "t - 出版日期和版權日期" },
                            { value: "u", label: "u - 連續性出版品出版現狀不詳" },
                            { value: "|", label: "| - 沒有嘗試編碼" }
                        ]}
                    />
                </Form.Item>
            </Col>
            <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                <Form.Item
                    label={t('date_1')}
                    {...field}
                    name={[field?.name ?? '', 'f7_f10']}
                    fieldKey={[field?.fieldKey ?? '', 'f7_f10']}
                >
                    <Input maxlength={"4"} />
                </Form.Item>
            </Col>
            <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                <Form.Item
                    {...field}
                    name={[field?.name ?? '', 'f11_f14']}
                    fieldKey={[field?.fieldKey ?? '', 'f11_f14']}
                    label={t('date_2')}
                >
                    <Input maxlength={"4"} />
                </Form.Item>
            </Col>
            <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                <Form.Item
                    {...field}
                    label={t('place_of_publication')}
                    name={[field?.name ?? '', 'f15_f17']}
                    fieldKey={[field?.fieldKey ?? '', 'f15_f17']}
                >
                    <Input maxlength={"3"} />
                </Form.Item>
            </Col>
            {!!materialType && getField008Positions18to34FormItems(materialType)}
            <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                <Form.Item
                    {...field}
                    name={[field?.name ?? '', 'f35_f37']}
                    fieldKey={[field?.fieldKey ?? '', 'f35_f37']}
                    label={t('language')}                                    >
                    <Input maxlength={"3"} />
                </Form.Item>
            </Col>
            <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                <Form.Item
                    {...field}
                    name={[field?.name ?? '', 'f38']}
                    fieldKey={[field?.fieldKey ?? '', 'f38']}
                    label={t('modified_record')}
                >
                    <Select
                        options={[
                            { value: " ", label: "# - 未修改" },
                            { value: "d", label: "d - 省略了帶劃線的信息" },
                            { value: "o", label: "o - 完全羅馬化/打印卡片羅馬化" },
                            { value: "r", label: "r - 完全羅馬化/打印卡片以書寫形式" },
                            { value: "s", label: "s - 縮短" },
                            { value: "x", label: "x - 缺少字符" },
                            { value: "|", label: "| - 未嘗試編碼" }
                        ]} />
                </Form.Item>
            </Col>
            <Col xxl={6} xl={6} lg={8} md={8} sm={12} xs={24}>
                <Form.Item
                    {...field}
                    name={[field?.name ?? '', 'f39']}
                    fieldKey={[field?.fieldKey ?? '', 'f39']}
                    label={t('cataloging_source')}
                >
                    <Select
                        options={[
                            { value: " ", label: "# - 國家書目機構" },
                            { value: "c", label: "c - 合作編目計劃" },
                            { value: "d", label: "d - 其他" },
                            { value: "u", label: "u - 未知" },
                            { value: "|", label: "| - 未嘗試編碼" }
                        ]} />
                </Form.Item>
            </Col>
        </Row >
    );
};


export default MARC008GeneratorForm;
